


























import { Component, Prop, Vue } from "vue-property-decorator";
type tapEvent = { target: HTMLElement };
@Component
export default class extends Vue {
  @Prop({ default: "zh" }) lang!: string;
  cutLanguage(e: tapEvent): void {
    let toLang: string | undefined = e.target.dataset.lang;
    window.localStorage.setItem("lang", toLang + "");
    window.location.reload();
    
    console.log("语言切换中....");
  }
}
